// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer {
  display: flex;
  justify-content: flex-end;
  padding: 8px 20px;
  align-items: center;
  gap: 8px;
  box-shadow: 0px -1px 0px 0px rgba(225, 227, 229, 1) inset;
}

.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer .refresh {
  padding: 0 8px;
}

.PFS-Page__PredictiveBundle-Management .pfs-feature-lock-card {
  padding: 50px 93px;
  margin: unset;
}

.PFS-Page__PredictiveBundle-Management .refresh .Polaris-Button__Icon {
  height: 14px;
}
.PFS-Page__PredictiveBundle-Management thead {
  background: var(--surface-subdued, #fafbfb);
}

.PFS-Page__PredictiveBundle-Management thead tr td {
  border-top: 1px solid var(--border-divider, #e1e3e5);
  border-bottom: 1px solid var(--border-divider, #e1e3e5);
}
.PFS-Page__PredictiveBundle-Management thead tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--border-divider, #e1e3e5);
}
.PFS-Page__PredictiveBundle-Management thead tr td div {
  color: rgba(109, 113, 117, 1);
}

.PFS-Page__PredictiveBundle-Management thead tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--border-divider, #e1e3e5);
}

.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions {
  padding-left: 0;
  padding-right: 0;
}
.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions > div {
  display: flex;
  justify-content: center;
}

.PFS-Page__PredictiveBundle-Management table .Polaris-DataTable__Cell--status .Polaris-Badge {
  font-weight: 500;
  padding: 2px 8px;
}

.PFS-Page__PredictiveBundle-Management
  table
  .Polaris-DataTable__Cell--status
  .Polaris-Badge--statusCritical {
  color: rgba(142, 31, 11, 1);
}
.PFS-Page__PredictiveBundle-Management .group_btn button svg {
  fill: var(--p-icon);
}
.PFS-Page__PredictiveBundle-Management .BC-Filters .search {
  min-width: 300px;
}

/* item */
.PFS-PredictiveBundleItem_BundleType .Polaris-Card {
  max-width: 936px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-title-content {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-content {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 6px 4px 4px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Grid {
  gap: 20px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card__Section {
  padding: 24px;
}

.PFS-PredictiveBundleItem_BundleType .recommendation-type--select {
  display: flex;
}
.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {
  padding: 12px !important;
}
.PFS-PredictiveBundleItem_BundleType .button-large > button {
  border-radius: 8px;
  background: rgba(250, 251, 251, 1);
  border: 1px solid rgba(250, 251, 251, 1);
}

.PFS-PredictiveBundleItem_BundleType .button-large > button:hover,
.PFS-PredictiveBundleItem_BundleType .isSelected > button {
  border: 1px solid rgba(31, 81, 153, 1);
  background: rgba(229, 239, 253, 1);
}

.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge {
  background: #ff30001a;
  font-size: 12px;
  font-weight: 400;
}

.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge > span {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background-clip: text;
  -webkit-text-fill-color: #0000;
  font-weight: 600;
  align-items: center;
  display: flex;
  font-size: 12px;
  gap: 4px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Text {
  width: 100%;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content > div {
  margin-top: 16px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .btn-img {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .main-img {
  height: 90px;
  width: 232px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .main-img {
  width: 346px;
}

.PFS-PredictiveBundleItem_BundleType
  .button-large
  .recommendation-type--select-content
  .btn-img
  > div {
  position: absolute;
  top: -10px;
  left: auto;
  right: auto;
  border: 1px solid rgba(201, 204, 207, 1);
  background: rgba(255, 255, 255, 1);
  width: auto;
  height: 24px;
  padding: 4px 8px;
  font-weight: 600;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  gap: 4px;
}
.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .btn-img > div {
  top: 0;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Content {
  display: block;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {
  align-items: unset;
}

.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-img,
.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-title {
  opacity: 0.5;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell,
.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large,
.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large .Polaris-Button {
  height: 100%;
}
.PFS-PredictiveBundleItem_BundleType .button-large .btn-unlock {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  color: rgba(31, 81, 153, 1);
}

.PFS-PredictiveBundleItem .setup-general-settings {
  padding: 4px;
}
.PFS-PredictiveBundleItem .setup-general-settings .settings {
  display: grid;
}

.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-content {
  padding: 12px;
  background-color: #f6f6f7;
  border-radius: 8px;
  margin-top: 10px;
}

.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products {
  display: flex;
  gap: 8px;
}
.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based {
  flex-basis: 288px;
}
.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based-products {
  flex-grow: 1;
}

.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based-products .Polaris-TextField__Suffix .Polaris-Icon__Svg {
  fill: #BABEC3;
}


.PFS-PredictiveBundleItem .setup-general-settings .field-helper {
  color: var(--p-text-subdued);
}

.PFS-PredictiveBundleItem .setup-general-settings .volume-discount {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .volume-discount .volume-discount-item > div {
  display: flex;
  gap: 12px;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .volume-discount
  .volume-discount-item
  > div
  > div:not(.remove-icon) {
  width: 270px;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .volume-discount
  .volume-discount-item
  .remove-icon {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list {
  border: 1px dashed rgba(225, 227, 229, 1);
  border-radius: 4px;
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul {
  list-style-type: none;
  padding: unset;
  margin: unset;
  align-items: center;
}
.PFS-PredictiveBundleItem .rule-group-block .product-list ul li {
  padding: 8px;
  margin-left: unset;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:first-child {
  padding-left: 4px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:nth-child(3) {
  flex: 1 1;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item__Action .Polaris-Icon svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem
  .rule-group-block
  .product-list
  .product-item__Action
  .Polaris-Icon:hover
  svg {
  fill: var(--p-icon);
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item {
  background: var(--surface-default, #fff);
  /* Divider/Bottom */
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item:last-child {
  /* Divider/Bottom */
  box-shadow: none;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list-note {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .prefix {
  font-weight: 600;
  color: #d72c0d;
}
.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .number-limit {
  font-weight: 600;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list {
  display: flex;
  gap: 40px;
  margin-top: 10px;
  max-height: 580px;
  overflow-y: auto;
  padding-right: 8px;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .column {
  flex: 1;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .column
  .Polaris-Stack--alignmentCenter
  .Polaris-Stack__Item:last-child {
  margin-left: auto;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .divider {
  border-bottom: 1px solid var(--p-divider);
  margin-top: 8px;
  margin-bottom: 10px;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Name
  .Polaris-Link--removeUnderline:hover {
  text-decoration: none;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .product-item__Action {
  padding-top: 8px;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Action
  .Polaris-Icon
  svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Action
  .Polaris-Icon:hover
  svg {
  fill: var(--p-icon);
}

/* .PFS-PredictiveBundleItem .setup-general-settings .item:not(:first-child) {
  padding-top: 20px;
  border-top: 1px solid rgba(225, 227, 229, 1);
} */

.PFS-PredictiveBundleItem .setup-general-settings .item:not(:last-child) {
  padding-bottom: 24px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item .field-title {
  font-weight: 600;
  line-height: 20px;
}

.PFS-PredictiveBundleItem .setup-general-settings .ai-based-primary-algorithm-helper-text {
  margin-top: 5px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item .field-helper {
  line-height: 20px;
  margin-bottom: 0.5rem;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount {
  display: flex;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .status > div,
.PFS-PredictiveBundleItem .setup-general-settings .discount > div {
  max-width: 288px;
  width: 288px;
}

.PFS-PredictiveBundleItem .setup-general-settings .placement .Polaris-ChoiceList__Choices {
  display: flex;
  gap: 32px;
}

.PFS-PredictiveBundleItem .setup-general-settings .Polaris-TextStyle--variationStrong {
  margin-bottom: 4px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item > p {
  margin-bottom: 8px;
}

.PFS-PredictiveBundleItem .bundle-display-type-items,
.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button {
  padding: 12px !important;
  align-items: unset;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button__Content {
  display: block;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button {
  border-radius: 8px;
  border: 1px solid var(--p-border-subdued);
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button:hover,
.PFS-PredictiveBundleItem .bundle-display-type-items .isSelected > button {
  border: 1px solid var(--p-interactive);
}

.PFS-PredictiveBundleItem
  .bundle-display-type-items
  .button-large
  .recommendation-type--select-content
  .btn-img {
  position: relative;
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .btn-title {
  margin-top: 16px;
  text-align: left;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-type-lock .btn-img {
  opacity: 0.5;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell,
.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell .button-large,
.PFS-PredictiveBundleItem
  .bundle-display-type-items
  .Polaris-Grid-Cell
  .button-large
  .Polaris-Button {
  height: 100%;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .btn-unlock {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  color: rgba(31, 81, 153, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-Card__Section {
  padding: 24px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner {
  margin-bottom: 32px;
}
.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(44, 110, 203, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link .Polaris-Icon {
  margin: unset;
  width: 15px;
  height: 15px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Banner__Content p {
  display: flex;
  gap: 3px;
}

.PFS-PredictiveBundleItem_Placement .tab-content-content .Polaris-Grid:not(:first-child),
.PFS-PredictiveBundleItem_Placement .content,
.PFS-PredictiveBundleItem_Placement .action {
  margin-top: 16px;
}

.PFS-PredictiveBundleItem_Placement .content .content-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem_Placement .tab-content .non-action .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 8px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField__Backdrop {
  border-radius: 8px;
  height: 44px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField {
  height: 44px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField .Polaris-TextField__Suffix {
  display: flex;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-TextField .Polaris-TextField__Input:disabled {
  color: rgba(32, 34, 35, 1);
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField {
  align-items: unset;
  margin-top: 4px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField__Input:disabled {
  -webkit-text-fill-color: #202223 !important;
  font-family: Monaco;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder textarea {
  font-size: 0.75rem;
  height: max-content !important;
  padding: 12px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder input {
  font-size: 0.75rem;
}

.PFS-PredictiveBundleItem_Placement
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix {
  margin: unset;
  padding: 5px 4px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-Button {
  margin: unset;
}

.PFS-PredictiveBundleItem_Placement .BC-Iframe-Container {
  border-radius: 2px;
}
.PFS-PredictiveBundleItem_Placement .banner-info .Polaris-Banner .Polaris-Banner__Content p {
  display: block !important;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .default-settings-widget {
  color: #6d7175;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item {
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
  cursor: pointer;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item .Polaris-Icon {
  margin-right: 0;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item:hover {
  background-color: #f1f1f1;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item__name {
  font-weight: 600;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title {
  display: flex;
  justify-content: flex-start;
  margin: -16px -20px 0;
  padding: 12px;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
  font-size: 1rem;
  font-weight: 600;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title .btn-back {
  cursor: pointer;
  margin-right: 8px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .bundle-thumbnail-settings {
  padding: 16px;
  border: 1px solid rgba(225, 227, 229, 1);
  border-radius: 4px;
  background: rgba(250, 251, 251, 1);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .widget-layout-settings
  .bundle-thumbnail-settings
  .product-image-wrapper {
  width: 50%;
  margin: auto;
}

.bundle-thumbnail-settings .product-image-div {
  display: grid;
  grid-gap: 4px;
  aspect-ratio: 3/4;
}

.bundle-thumbnail-settings .product-image {
  overflow: hidden;
}

.bundle-thumbnail-settings .product-image-img {
  width: 100%;
}

.bundle-thumbnail-settings .product-image-div.image-with-2 {
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: 1fr;
}

.bundle-thumbnail-settings .product-image-div.image-with-3 {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

.bundle-thumbnail-settings .product-image-div.image-with-4 {
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
}

.bundle-thumbnail-settings .product-image-img-sub {
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: 100%;
  transition: transform 0.3s;
  display: block;
}

/* .bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:first-child {
  width: 100%;

  clip-path: inset(0 0 calc(50% + 2px) 0);
  margin-bottom: calc(-50% - 2px);
}

.bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:last-child {
  width: 100%;
  clip-path: inset(calc(50% + 2px) 0 0 0);
  margin-top: calc(-50% - 2px);
} */

.bundle-thumbnail-settings button {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {
  height: calc(100vh - 92px);
  width: calc(100% - 300px);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-items
  .product-image-wrapper
  img[alt='plus'] {
  width: 16px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-items
  .product-image-card
  .product-image--has-border {
  border: 1.19px solid #e4e4e9;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-items
  .product-image-card {
  overflow-x: hidden;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_general-page
  .item-detail-preview {
  margin-right: 24px;
}

.PFS-PredictiveBundleItem .boost-sd__instant-search-autocomplete {
  z-index: 14;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_instant-search-widget
  .recommendation-title,
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_instant-search-widget
  .recommendation-title-left {
  margin: 0 0 20px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_product-volume-page {
  padding: 32px 20%;
}

.widget-visual-editor
  .visual-editor-body
  .bundle-preview_product-volume-page
  .recommendation-title {
  margin: 40px auto !important;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_product-volume-page > div {
  max-width: 483px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_product-volume-page
  .volume-item
  .info {
  display: flex;
}
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_product-volume-page
  .volume-item
  .info
  > div {
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .discount {
  display: flex;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item {
  display: flex;
  align-items: center;
  gap: 16px;
}
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item > div {
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .total {
  text-align: end !important;
}
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content {
  color: black;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content svg {
  fill: black;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .recommendation-bundle.recommendation-bundle--instant-search-widget {
  padding-top: 40px;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .recommendation-bundle-body,
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .recommendation-bundle-body
  .add-to-cart {
  width: 100% !important;
  max-width: unset;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item {
  border-radius: 8px;
  padding: 24px 20px;
  border: 1px solid #d2d5d8;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight {
  position: relative;
  border: 1px solid #D2D5D8;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight > .highlight {
  position: absolute;
  top: -15px;
  border-radius: 2px;
}

.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .Polaris-RadioButton__Input:checked
  + .Polaris-RadioButton__Backdrop {
  border-color: #008060;

}
.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .Polaris-RadioButton__Backdrop::before {  
  background-color: var(--before-color, black);
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-wrapper,
.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {
  justify-content: center;
  align-items: center;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart {
  width: 100%;
  box-shadow: inset 0 1px 0 #e4e5e7;
  padding-top: 12px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart-inner {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .cart-inner {
  flex-direction: column;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .total {
  width: auto;
  text-align: left;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .add-to-cart {
  width: 100% !important;
  max-width: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .hasAspectRatio {
  aspect-ratio: 3/4;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__suggestion-queries-item-product--left:before {
  content: none !important;
}

.PFS-PredictiveBundleItem .options-preview {
  align-items: center;
  display: flex;
  height: 100%;
}

.PFS-PredictiveBundleItem .options-preview-label {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.PFS-PredictiveBundleItem .select-option-preview {
  min-width: 300px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__suggestion-queries-group
  .boost-sd__suggestion-queries-link {
  padding: 6px 12px;
}

@media only screen and (min-width: 1200px) {
  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-left
    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(
      .boost-sd__instant-search-no-other
    )
    .boost-sd__instant-search-column--products,
  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-right
    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(
      .boost-sd__instant-search-no-other
    )
    .boost-sd__instant-search-column--products {
    width: calc(100% - 248px);
  }

  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width
    .boost-sd__instant-search-column--others {
    width: 224px;
  }
}

/* skeleton custom */
.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText {
  height: var(--p-space-3);
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText + .Polaris-SkeletonBodyText {
  margin-top: var(--p-space-2);
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth {
  width: 100%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth.hasMax {
  max-width: 200px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width {
  width: 80%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width.hasMax {
  max-width: 160px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width {
  width: 60%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width.hasMax {
  max-width: 120px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width {
  width: 50%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width.hasMax {
  max-width: 100px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width {
  width: 30%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width.hasMax {
  max-width: 60px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width {
  width: 20%;
}
.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width.hasMax {
  max-width: 40px;
}

.PFS-PredictiveBundleItem .recommendation-note.instant-search-widget {
  text-align: left;
}

.PFS-PredictiveBundleItem .item-tab {
  margin-top: 16px;
  padding: 20px;
  background-color: #fafbfb;
  border-radius: 8px;
}

.PFS-PredictiveBundleItem .item-tab.tab-collapse {
  background: #ffffff;
  padding: 16px 20px;
  border: 1px solid #e1e3e5;
}

.PFS-PredictiveBundleItem .item-tab .item-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  border-radius: 8px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading:hover {
  /* background-color: #f6f6f7; */
  cursor: pointer;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .icon {
  width: 20px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
  gap: 3px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .title .Polaris-Icon,
.PFS-PredictiveBundleItem .item-tab .item-heading .title .title-order {
  margin-right: 8px;
}

.PFS-PredictiveBundleItem .item-tab .Polaris-Collapsible {
  margin-top: 16px;
}

.BC-Page__SelectImageThumbnailModal .product-default-images {
  width: 100%;
  display: flex;
}

.BC-Page__SelectImageThumbnailModal .product-image-wrapper {
  position: relative;
  width: calc(20% - 10px);
  margin-left: 10px;
  border: var(--p-border-divider);
  border-radius: 4px;
  padding: 8px;
  min-height: 149px;
}

.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper:hover {
  border-color: var(--p-border-hovered);
}
.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper.selected {
  border-color: var(--p-interactive);
  background: rgba(229, 239, 253, 1);
}

.BC-Page__SelectImageThumbnailModal .product-image-img {
  width: 100%;
}

.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper .Polaris-Icon {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(44, 110, 203, 1);
}

.BC-Page__SelectImageThumbnailModal
  .product-default-images
  .product-image-wrapper
  .Polaris-Icon
  svg {
  fill: rgba(255, 255, 255, 1);
}

.BC-Page__SelectImageVolumeModal .Polaris-Modal-Section > div {
  display: flex;
  gap: 10px;
  align-items: start;
}

.BC-Page__SelectImageVolumeModal .product-image-div {
  max-width: 112px;
  width: 112px;
  height: 144px;
  padding: 8px;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
}
.BC-Page__SelectImageVolumeModal .product-image {
  max-width: 100%;
  height: auto;
}
.custom-dropzone-bundle {
  padding-top: 0;
}

.custom-dropzone-bundle.uploaded {
  display: flex;
  gap: 8px;
}

.custom-dropzone-bundle.uploaded .dropzone-area {
  width: 40%;
}

.custom-dropzone-bundle .dropzone-content {
  background: #e5effd;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #1f5199;
  width: fit-content;
  border-radius: 4px;
  margin: 0 auto 8px;
}

.custom-dropzone-bundle .Polaris-TextStyle--variationSubdued {
  font-size: 12px;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone {
  color: #d82c0d;
  size: 12px;
  font-weight: 600;
  min-height: 76px;
  align-items: center;
  background-color: #fff4f4;
}

.custom-dropzone-bundle.uploaded-error
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),
.custom-dropzone-bundle.uploaded-error
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {
  border-color: #fd5749;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error {
  text-align: center;
  font-size: 12px;
}
.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:first-child {
  font-weight: 600;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:last-child {
  font-weight: 400 !important;
}

/* Product */
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-list {
  margin: 24px 32px;
  gap: 32px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item {
  width: calc(33.33% - 32px);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item
  .boost-sd__product-image {
  min-height: 372px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item
  .product-info
  .Polaris-SkeletonBodyText.skeleton-80Width {
  max-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/bundle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,yDAAyD;AAC3D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;AACvD;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;;;EAKE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;AACf;AACA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;;AAEvB;AACA;;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE;;;;;;;;;;;;IAYE,yBAAyB;EAC3B;;EAEA;;;IAGE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;;;;EAIE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;EAME,eAAe;AACjB","sourcesContent":[".PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 20px;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0px -1px 0px 0px rgba(225, 227, 229, 1) inset;\n}\n\n.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer .refresh {\n  padding: 0 8px;\n}\n\n.PFS-Page__PredictiveBundle-Management .pfs-feature-lock-card {\n  padding: 50px 93px;\n  margin: unset;\n}\n\n.PFS-Page__PredictiveBundle-Management .refresh .Polaris-Button__Icon {\n  height: 14px;\n}\n.PFS-Page__PredictiveBundle-Management thead {\n  background: var(--surface-subdued, #fafbfb);\n}\n\n.PFS-Page__PredictiveBundle-Management thead tr td {\n  border-top: 1px solid var(--border-divider, #e1e3e5);\n  border-bottom: 1px solid var(--border-divider, #e1e3e5);\n}\n.PFS-Page__PredictiveBundle-Management thead tr td:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid var(--border-divider, #e1e3e5);\n}\n.PFS-Page__PredictiveBundle-Management thead tr td div {\n  color: rgba(109, 113, 117, 1);\n}\n\n.PFS-Page__PredictiveBundle-Management thead tr td:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions {\n  padding-left: 0;\n  padding-right: 0;\n}\n.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions > div {\n  display: flex;\n  justify-content: center;\n}\n\n.PFS-Page__PredictiveBundle-Management table .Polaris-DataTable__Cell--status .Polaris-Badge {\n  font-weight: 500;\n  padding: 2px 8px;\n}\n\n.PFS-Page__PredictiveBundle-Management\n  table\n  .Polaris-DataTable__Cell--status\n  .Polaris-Badge--statusCritical {\n  color: rgba(142, 31, 11, 1);\n}\n.PFS-Page__PredictiveBundle-Management .group_btn button svg {\n  fill: var(--p-icon);\n}\n.PFS-Page__PredictiveBundle-Management .BC-Filters .search {\n  min-width: 300px;\n}\n\n/* item */\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card {\n  max-width: 936px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-title-content {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-content {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 6px 4px 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid {\n  gap: 20px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card__Section {\n  padding: 24px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .recommendation-type--select {\n  display: flex;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {\n  padding: 12px !important;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large > button {\n  border-radius: 8px;\n  background: rgba(250, 251, 251, 1);\n  border: 1px solid rgba(250, 251, 251, 1);\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large > button:hover,\n.PFS-PredictiveBundleItem_BundleType .isSelected > button {\n  border: 1px solid rgba(31, 81, 153, 1);\n  background: rgba(229, 239, 253, 1);\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge {\n  background: #ff30001a;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge > span {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background-clip: text;\n  -webkit-text-fill-color: #0000;\n  font-weight: 600;\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  gap: 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Text {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content > div {\n  margin-top: 16px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .btn-img {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .main-img {\n  height: 90px;\n  width: 232px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .main-img {\n  width: 346px;\n}\n\n.PFS-PredictiveBundleItem_BundleType\n  .button-large\n  .recommendation-type--select-content\n  .btn-img\n  > div {\n  position: absolute;\n  top: -10px;\n  left: auto;\n  right: auto;\n  border: 1px solid rgba(201, 204, 207, 1);\n  background: rgba(255, 255, 255, 1);\n  width: auto;\n  height: 24px;\n  padding: 4px 8px;\n  font-weight: 600;\n  border-radius: 4px;\n  font-size: 12px;\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .btn-img > div {\n  top: 0;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Content {\n  display: block;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {\n  align-items: unset;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-img,\n.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-title {\n  opacity: 0.5;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell,\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large,\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large .Polaris-Button {\n  height: 100%;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-unlock {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration: underline;\n  color: rgba(31, 81, 153, 1);\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings {\n  padding: 4px;\n}\n.PFS-PredictiveBundleItem .setup-general-settings .settings {\n  display: grid;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-content {\n  padding: 12px;\n  background-color: #f6f6f7;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products {\n  display: flex;\n  gap: 8px;\n}\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based {\n  flex-basis: 288px;\n}\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based-products {\n  flex-grow: 1;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-bundle-based-products .select-bundle-based-products .Polaris-TextField__Suffix .Polaris-Icon__Svg {\n  fill: #BABEC3;\n}\n\n\n.PFS-PredictiveBundleItem .setup-general-settings .field-helper {\n  color: var(--p-text-subdued);\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .volume-discount {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .volume-discount .volume-discount-item > div {\n  display: flex;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .volume-discount\n  .volume-discount-item\n  > div\n  > div:not(.remove-icon) {\n  width: 270px;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .volume-discount\n  .volume-discount-item\n  .remove-icon {\n  display: flex;\n  align-items: center;\n  margin-top: 24px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list {\n  border: 1px dashed rgba(225, 227, 229, 1);\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul {\n  list-style-type: none;\n  padding: unset;\n  margin: unset;\n  align-items: center;\n}\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li {\n  padding: 8px;\n  margin-left: unset;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:first-child {\n  padding-left: 4px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:nth-child(3) {\n  flex: 1 1;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item__Action .Polaris-Icon svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .rule-group-block\n  .product-list\n  .product-item__Action\n  .Polaris-Icon:hover\n  svg {\n  fill: var(--p-icon);\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item {\n  background: var(--surface-default, #fff);\n  /* Divider/Bottom */\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item:last-child {\n  /* Divider/Bottom */\n  box-shadow: none;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .prefix {\n  font-weight: 600;\n  color: #d72c0d;\n}\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .number-limit {\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list {\n  display: flex;\n  gap: 40px;\n  margin-top: 10px;\n  max-height: 580px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .column {\n  flex: 1;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .column\n  .Polaris-Stack--alignmentCenter\n  .Polaris-Stack__Item:last-child {\n  margin-left: auto;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .divider {\n  border-bottom: 1px solid var(--p-divider);\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Name\n  .Polaris-Link--removeUnderline:hover {\n  text-decoration: none;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .product-item__Action {\n  padding-top: 8px;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Action\n  .Polaris-Icon\n  svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Action\n  .Polaris-Icon:hover\n  svg {\n  fill: var(--p-icon);\n}\n\n/* .PFS-PredictiveBundleItem .setup-general-settings .item:not(:first-child) {\n  padding-top: 20px;\n  border-top: 1px solid rgba(225, 227, 229, 1);\n} */\n\n.PFS-PredictiveBundleItem .setup-general-settings .item:not(:last-child) {\n  padding-bottom: 24px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item .field-title {\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .ai-based-primary-algorithm-helper-text {\n  margin-top: 5px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item .field-helper {\n  line-height: 20px;\n  margin-bottom: 0.5rem;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount {\n  display: flex;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .status > div,\n.PFS-PredictiveBundleItem .setup-general-settings .discount > div {\n  max-width: 288px;\n  width: 288px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .placement .Polaris-ChoiceList__Choices {\n  display: flex;\n  gap: 32px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .Polaris-TextStyle--variationStrong {\n  margin-bottom: 4px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item > p {\n  margin-bottom: 8px;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items,\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button {\n  padding: 12px !important;\n  align-items: unset;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button__Content {\n  display: block;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button {\n  border-radius: 8px;\n  border: 1px solid var(--p-border-subdued);\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button:hover,\n.PFS-PredictiveBundleItem .bundle-display-type-items .isSelected > button {\n  border: 1px solid var(--p-interactive);\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-display-type-items\n  .button-large\n  .recommendation-type--select-content\n  .btn-img {\n  position: relative;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .btn-title {\n  margin-top: 16px;\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-type-lock .btn-img {\n  opacity: 0.5;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell,\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell .button-large,\n.PFS-PredictiveBundleItem\n  .bundle-display-type-items\n  .Polaris-Grid-Cell\n  .button-large\n  .Polaris-Button {\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .btn-unlock {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration: underline;\n  color: rgba(31, 81, 153, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Card__Section {\n  padding: 24px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner {\n  margin-bottom: 32px;\n}\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(44, 110, 203, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link .Polaris-Icon {\n  margin: unset;\n  width: 15px;\n  height: 15px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Banner__Content p {\n  display: flex;\n  gap: 3px;\n}\n\n.PFS-PredictiveBundleItem_Placement .tab-content-content .Polaris-Grid:not(:first-child),\n.PFS-PredictiveBundleItem_Placement .content,\n.PFS-PredictiveBundleItem_Placement .action {\n  margin-top: 16px;\n}\n\n.PFS-PredictiveBundleItem_Placement .content .content-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem_Placement .tab-content .non-action .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField__Backdrop {\n  border-radius: 8px;\n  height: 44px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField {\n  height: 44px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField .Polaris-TextField__Suffix {\n  display: flex;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-TextField .Polaris-TextField__Input:disabled {\n  color: rgba(32, 34, 35, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField {\n  align-items: unset;\n  margin-top: 4px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField__Input:disabled {\n  -webkit-text-fill-color: #202223 !important;\n  font-family: Monaco;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder textarea {\n  font-size: 0.75rem;\n  height: max-content !important;\n  padding: 12px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder input {\n  font-size: 0.75rem;\n}\n\n.PFS-PredictiveBundleItem_Placement\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix {\n  margin: unset;\n  padding: 5px 4px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-Button {\n  margin: unset;\n}\n\n.PFS-PredictiveBundleItem_Placement .BC-Iframe-Container {\n  border-radius: 2px;\n}\n.PFS-PredictiveBundleItem_Placement .banner-info .Polaris-Banner .Polaris-Banner__Content p {\n  display: block !important;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .default-settings-widget {\n  color: #6d7175;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item {\n  display: flex;\n  padding: 10px 0;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n  cursor: pointer;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item .Polaris-Icon {\n  margin-right: 0;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item:hover {\n  background-color: #f1f1f1;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item__name {\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title {\n  display: flex;\n  justify-content: flex-start;\n  margin: -16px -20px 0;\n  padding: 12px;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title .btn-back {\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .bundle-thumbnail-settings {\n  padding: 16px;\n  border: 1px solid rgba(225, 227, 229, 1);\n  border-radius: 4px;\n  background: rgba(250, 251, 251, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .widget-layout-settings\n  .bundle-thumbnail-settings\n  .product-image-wrapper {\n  width: 50%;\n  margin: auto;\n}\n\n.bundle-thumbnail-settings .product-image-div {\n  display: grid;\n  grid-gap: 4px;\n  aspect-ratio: 3/4;\n}\n\n.bundle-thumbnail-settings .product-image {\n  overflow: hidden;\n}\n\n.bundle-thumbnail-settings .product-image-img {\n  width: 100%;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-2 {\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: 1fr;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-3 {\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-4 {\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.bundle-thumbnail-settings .product-image-img-sub {\n  object-fit: cover;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  transition: transform 0.3s;\n  display: block;\n}\n\n/* .bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:first-child {\n  width: 100%;\n\n  clip-path: inset(0 0 calc(50% + 2px) 0);\n  margin-bottom: calc(-50% - 2px);\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:last-child {\n  width: 100%;\n  clip-path: inset(calc(50% + 2px) 0 0 0);\n  margin-top: calc(-50% - 2px);\n} */\n\n.bundle-thumbnail-settings button {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {\n  height: calc(100vh - 92px);\n  width: calc(100% - 300px);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-items\n  .product-image-wrapper\n  img[alt='plus'] {\n  width: 16px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-items\n  .product-image-card\n  .product-image--has-border {\n  border: 1.19px solid #e4e4e9;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-items\n  .product-image-card {\n  overflow-x: hidden;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_general-page\n  .item-detail-preview {\n  margin-right: 24px;\n}\n\n.PFS-PredictiveBundleItem .boost-sd__instant-search-autocomplete {\n  z-index: 14;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_instant-search-widget\n  .recommendation-title,\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_instant-search-widget\n  .recommendation-title-left {\n  margin: 0 0 20px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_product-volume-page {\n  padding: 32px 20%;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_product-volume-page\n  .recommendation-title {\n  margin: 40px auto !important;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_product-volume-page > div {\n  max-width: 483px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_product-volume-page\n  .volume-item\n  .info {\n  display: flex;\n}\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_product-volume-page\n  .volume-item\n  .info\n  > div {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .discount {\n  display: flex;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item > div {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .total {\n  text-align: end !important;\n}\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content {\n  color: black;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content svg {\n  fill: black;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .recommendation-bundle.recommendation-bundle--instant-search-widget {\n  padding-top: 40px;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .recommendation-bundle-body,\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .recommendation-bundle-body\n  .add-to-cart {\n  width: 100% !important;\n  max-width: unset;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item {\n  border-radius: 8px;\n  padding: 24px 20px;\n  border: 1px solid #d2d5d8;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight {\n  position: relative;\n  border: 1px solid #D2D5D8;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight > .highlight {\n  position: absolute;\n  top: -15px;\n  border-radius: 2px;\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .Polaris-RadioButton__Input:checked\n  + .Polaris-RadioButton__Backdrop {\n  border-color: #008060;\n\n}\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .Polaris-RadioButton__Backdrop::before {  \n  background-color: var(--before-color, black);\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-wrapper,\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {\n  justify-content: center;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart {\n  width: 100%;\n  box-shadow: inset 0 1px 0 #e4e5e7;\n  padding-top: 12px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .cart-inner {\n  flex-direction: column;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .total {\n  width: auto;\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .total {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .add-to-cart {\n  width: 100% !important;\n  max-width: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .hasAspectRatio {\n  aspect-ratio: 3/4;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__suggestion-queries-item-product--left:before {\n  content: none !important;\n}\n\n.PFS-PredictiveBundleItem .options-preview {\n  align-items: center;\n  display: flex;\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .options-preview-label {\n  margin-right: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.PFS-PredictiveBundleItem .select-option-preview {\n  min-width: 300px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__suggestion-queries-group\n  .boost-sd__suggestion-queries-link {\n  padding: 6px 12px;\n}\n\n@media only screen and (min-width: 1200px) {\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-left\n    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(\n      .boost-sd__instant-search-no-other\n    )\n    .boost-sd__instant-search-column--products,\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-right\n    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(\n      .boost-sd__instant-search-no-other\n    )\n    .boost-sd__instant-search-column--products {\n    width: calc(100% - 248px);\n  }\n\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width\n    .boost-sd__instant-search-column--others {\n    width: 224px;\n  }\n}\n\n/* skeleton custom */\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText {\n  height: var(--p-space-3);\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText + .Polaris-SkeletonBodyText {\n  margin-top: var(--p-space-2);\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth.hasMax {\n  max-width: 200px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width {\n  width: 80%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width.hasMax {\n  max-width: 160px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width {\n  width: 60%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width.hasMax {\n  max-width: 120px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width {\n  width: 50%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width.hasMax {\n  max-width: 100px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width {\n  width: 30%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width.hasMax {\n  max-width: 60px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width {\n  width: 20%;\n}\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width.hasMax {\n  max-width: 40px;\n}\n\n.PFS-PredictiveBundleItem .recommendation-note.instant-search-widget {\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem .item-tab {\n  margin-top: 16px;\n  padding: 20px;\n  background-color: #fafbfb;\n  border-radius: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab.tab-collapse {\n  background: #ffffff;\n  padding: 16px 20px;\n  border: 1px solid #e1e3e5;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  border-radius: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading:hover {\n  /* background-color: #f6f6f7; */\n  cursor: pointer;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .icon {\n  width: 20px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-start;\n  gap: 3px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .title .Polaris-Icon,\n.PFS-PredictiveBundleItem .item-tab .item-heading .title .title-order {\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .Polaris-Collapsible {\n  margin-top: 16px;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images {\n  width: 100%;\n  display: flex;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-image-wrapper {\n  position: relative;\n  width: calc(20% - 10px);\n  margin-left: 10px;\n  border: var(--p-border-divider);\n  border-radius: 4px;\n  padding: 8px;\n  min-height: 149px;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper:hover {\n  border-color: var(--p-border-hovered);\n}\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper.selected {\n  border-color: var(--p-interactive);\n  background: rgba(229, 239, 253, 1);\n}\n\n.BC-Page__SelectImageThumbnailModal .product-image-img {\n  width: 100%;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper .Polaris-Icon {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(44, 110, 203, 1);\n}\n\n.BC-Page__SelectImageThumbnailModal\n  .product-default-images\n  .product-image-wrapper\n  .Polaris-Icon\n  svg {\n  fill: rgba(255, 255, 255, 1);\n}\n\n.BC-Page__SelectImageVolumeModal .Polaris-Modal-Section > div {\n  display: flex;\n  gap: 10px;\n  align-items: start;\n}\n\n.BC-Page__SelectImageVolumeModal .product-image-div {\n  max-width: 112px;\n  width: 112px;\n  height: 144px;\n  padding: 8px;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n}\n.BC-Page__SelectImageVolumeModal .product-image {\n  max-width: 100%;\n  height: auto;\n}\n.custom-dropzone-bundle {\n  padding-top: 0;\n}\n\n.custom-dropzone-bundle.uploaded {\n  display: flex;\n  gap: 8px;\n}\n\n.custom-dropzone-bundle.uploaded .dropzone-area {\n  width: 40%;\n}\n\n.custom-dropzone-bundle .dropzone-content {\n  background: #e5effd;\n  padding: 4px 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1f5199;\n  width: fit-content;\n  border-radius: 4px;\n  margin: 0 auto 8px;\n}\n\n.custom-dropzone-bundle .Polaris-TextStyle--variationSubdued {\n  font-size: 12px;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone {\n  color: #d82c0d;\n  size: 12px;\n  font-weight: 600;\n  min-height: 76px;\n  align-items: center;\n  background-color: #fff4f4;\n}\n\n.custom-dropzone-bundle.uploaded-error\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),\n.custom-dropzone-bundle.uploaded-error\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {\n  border-color: #fd5749;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error {\n  text-align: center;\n  font-size: 12px;\n}\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:first-child {\n  font-weight: 600;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:last-child {\n  font-weight: 400 !important;\n}\n\n/* Product */\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-list {\n  margin: 24px 32px;\n  gap: 32px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item {\n  width: calc(33.33% - 32px);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item\n  .boost-sd__product-image {\n  min-height: 372px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item\n  .product-info\n  .Polaris-SkeletonBodyText.skeleton-80Width {\n  max-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
